import React, { useContext, useMemo } from "react";
import { FaFacebook, FaYoutube, FaLinkedin, FaInstagram, FaTiktok, FaTwitter } from "react-icons/fa";
import { UserConfigContext } from "../../../context/UserConfigContext";

const Footer = () => {
  const { config1 } = useContext(UserConfigContext);

  // Memoizamos toda la información de empresa y ecommerce
  const empresaData = useMemo(() => {
    const ecommerce = config1?.config_ecommerce || {};
    const empresa = config1?.empresa || {};

    return {
      logo: empresa?.logo || "",
      nosotros: ecommerce?.nosotros || "",
      horario: ecommerce?.horario || "",
      mobile: ecommerce?.mobile || "",
      telefono: ecommerce?.telefono || "",
      email: ecommerce?.email || "",
      direccion: empresa?.direccion || "",
      url_facebook: ecommerce?.url_facebook || "",
      url_instagram: ecommerce?.url_instagram || "",
      url_linkedin: ecommerce?.url_linkedin || "",
      url_tiktok: ecommerce?.url_tiktok || "",
      url_twitter: ecommerce?.url_twitter || "",
      url_youtube: ecommerce?.url_youtube || "",
    };
  }, [config1]);

  // Memoizamos la URL del mapa para que solo se genere una vez
  const mapSrc = useMemo(() => {
    if (!empresaData.direccion) return "";
    return `https://www.google.com/maps?q=${encodeURIComponent(
      empresaData.direccion + ", Argentina"
    )}&output=embed`;
  }, [empresaData.direccion]);

  return (
    <div className="w-full bg-[#F5F5F3]">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 px-4 items-center">
        
        {/* Columna 1 - Logo y texto */}
        <div className="flex flex-col items-start justify-center text-left gap-4">
          {empresaData.logo && (
            <img src={empresaData.logo} alt="Logo Empresa" className="w-32 h-auto" />
          )}
          <p className="text-base max-w-xs">{empresaData.nosotros}</p>
        </div>

        {/* Columna 2 - Mapa */}
        <div className="col-span-1 flex items-center justify-center p-0 m-0">
          {mapSrc && (
            <iframe
              className="w-full h-60 md:h-48 lg:h-60 xl:h-72 border-0 drop-shadow-[4px_0_6px_rgba(0,0,0,0.2)]"
              src={mapSrc}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación empresa"
            ></iframe>
          )}
        </div>

        {/* Columna 3 - Redes y contacto */}
        <div className="flex flex-col items-end justify-center text-right gap-3">
          <ul className="flex items-center justify-end gap-2 mb-2">
            {empresaData.url_youtube && (
              <a href={empresaData.url_youtube} target="_blank" rel="noreferrer">
                <li className="icon-style"><FaYoutube /></li>
              </a>
            )}
            {empresaData.url_tiktok && (
              <a href={empresaData.url_tiktok} target="_blank" rel="noreferrer">
                <li className="icon-style"><FaTiktok /></li>
              </a>
            )}
            {empresaData.url_instagram && (
              <a href={empresaData.url_instagram} target="_blank" rel="noreferrer">
                <li className="icon-style"><FaInstagram /></li>
              </a>
            )}
            {empresaData.url_facebook && (
              <a href={empresaData.url_facebook} target="_blank" rel="noreferrer">
                <li className="icon-style"><FaFacebook /></li>
              </a>
            )}
            {empresaData.url_linkedin && (
              <a href={empresaData.url_linkedin} target="_blank" rel="noreferrer">
                <li className="icon-style"><FaLinkedin /></li>
              </a>
            )}
            {empresaData.url_twitter && (
              <a href={empresaData.url_twitter} target="_blank" rel="noreferrer">
                <li className="icon-style"><FaTwitter /></li>
              </a>
            )}
          </ul>
          {(empresaData.direccion) && (  
            <p className="text-base">Dirección: {empresaData.direccion}</p>
          )}
          {(empresaData.mobile || empresaData.telefono) && (
            <p className="text-base">Teléfono: {empresaData.mobile || empresaData.telefono}</p>
          )}
          {(empresaData.email) && (  
            <p className="text-base">Email: {empresaData.email}</p>
          )}
          {(empresaData.horario) && (  
            <p className="text-base">Horario: {empresaData.horario}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Footer;
